import React from 'react'
import { ConditionalWrapperProps } from './ConditionalWrapper.d'

const ConditionalWrapper = ({
  condition,
  wrapper,
  children
}: ConditionalWrapperProps) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  const wrapperElement = condition ? wrapper(<>{children}</>) : <>{children}</>

  return wrapperElement
}

export default ConditionalWrapper
